import $$ from 'cmn-utils';
import { routerRedux } from 'dva';
import modelEnhance from '@/utils/modelEnhance';

import { logout } from '../routes/Login/service';

import { UserRoleHash } from '../routes/User/Manage/components/data';

export default modelEnhance({
    namespace: 'global',

    state: {
        menu: [],
        flatMenu: [],
    },

    effects: {
        *getMenu({ payload }, { call, put }) {
            //const { status, data } = yield call(getMenu, payload);

            const data = getMenu();

            const loopMenu = (menu, pitem = {}) => {
                menu.forEach(item => {
                    if (pitem.path) {
                        item.parentPath = pitem.parentPath ? pitem.parentPath.concat(pitem.path) : [pitem.path];
                    }
                    if (item.children && item.children.length) {
                        loopMenu(item.children, item);
                    }
                });
            }
            loopMenu(data);

            yield put({
                type: 'getMenuSuccess',
                payload: data,
            });

        },
        *logout(_, { call, put }) {
            try {
                yield call(logout, _);

                $$.store.session('user', "");
                $$.store.session('session_id', "");

                yield put(routerRedux.replace('/sign/login'));
            }
            catch (e) {
                console.log(e);
            }
        }
    },

    reducers: {
        getMenuSuccess(state, { payload }) {
            return {
                ...state,
                menu: payload,
                flatMenu: getFlatMenu(payload),
            };
        }
    },
});

export function getFlatMenu(menus) {
    let menu = [];
    menus.forEach(item => {
        if (item.children) {
            menu = menu.concat(getFlatMenu(item.children));
        }
        menu.push(item);
    });
    return menu;
}

export function getMenu() {

    const user = $$.store.session('user');

    let menu = [
        {
            name: '首页',
            icon: 'DashboardOutlined',
            path: '/dashboard',
        },
        {
            name: '测速统计',
            icon: 'ThunderboltOutlined',
            path: '/monitor',
            children: [
                {
                    name: '实时查询',
                    path: '/realtime',
                    icon: 'FieldTimeOutlined'
                },
                {
                    name: '项目统计',
                    path: '/speed/host',
                    icon: 'AreaChartOutlined',
                    sub: ['/speed/page/:id', '/speed/monitor/:id']
                }
            ]
        },
        {
            name: '错误统计',
            icon: 'BugOutlined',
            path: '/badjs',
            children: [
                {
                    name: '实时查询',
                    path: '/badjs/realtime',
                    icon: 'FieldTimeOutlined'
                },
                {
                    name: '项目统计',
                    path: '/badjs/host',
                    icon: 'AreaChartOutlined',
                    sub: ['/badjs/list/:id', '/badjs/detail/:id']
                }
            ]
        }
    ];

    if (!user) return menu;

    if (user.role == UserRoleHash.Admin) {

        menu.push(
            {
                name: '用户管理',
                icon: 'TeamOutlined',
                path: '/user',
                children: [
                    {
                        name: '用户列表',
                        path: '/user/list',
                        icon: 'UserOutlined'
                    }
                ]
            });

        menu.push(
            {
                name: '系统设置',
                icon: 'SettingOutlined',
                path: '/setting'
            });
    }

    return menu;
}